<template>
	<div>
		<b-container fluid class="margin-top-header">
			<h1 class="pt-5 pb-4 text-center">Iniciar Sesión</h1>
			<v-section-header>
				<b-col md="4" cols="12" offset-md="4" > 
					<b-row>
						<b-col class="">
							<b-alert class="" v-if="this.error" variant="danger" show>{{ error }}</b-alert>
						</b-col>
						<b-col cols="12">
							<b-form-group label="Rut" >
								<b-form-input v-model.trim="$v.user.rut.$model" :state="$v.user.rut.$dirty ? !$v.user.rut.$error : null"  @keyup="formatRut"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Rut Inválido.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="password" label="Contraseña" >
								<b-form-input type="password" v-model="user.password"  trim></b-form-input>
							</b-form-group>
						</b-col>
						<b-col  cols="12" class="text-center">
							<a href="https://www.macal.cl/MiSitio/Usuario/Recuperar">No recuerdo mi contraseña.</a>
						</b-col>
						<b-col v-if="loading" cols="12" class="text-center mt-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-button size="lg" class=" mt-3 pl-5 pr-5" variant="outline-macal" @click="loginUser" :disabled="loading">Entrar</b-button>
						</b-col>
						<b-col cols="12" class="text-center">
							<hr>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-link to="/usuarios/nuevo">¿No tienes un cuenta?, Regístrate</b-link>
						</b-col>
					</b-row>
				</b-col>
			</v-section-header>
		</b-container>
	</div>
</template>

<script>
	import SectionHeader from "../../components/section-header";
	import { required } from "vuelidate/lib/validators";
	import { isRutValid } from "@/validators";

  export default {
	name: 'Index',
	data (){
		return {
			user: {
				rut: null,
				password: null,
			},
			terms: null,
			termsState: null,
			error: null,
			loading: false,
			color: "#E4610C"
		}
	},
	validations: {
		user:{
			rut: { required, RutValid: isRutValid },
		}
	},
	components: {
		'v-section-header': SectionHeader,
	},
	mounted(){
		if(this.$store.state.isLogged){
			this.$router.push('/');
		}
	},
	methods: {
		scrollFromHead() {
			window.scroll({
				top: document.querySelector('.scroll-receiver').offsetTop - 150, 
				behavior: 'smooth'
			});
		},
		formatRut(){
			this.user.rut = this.user.rut.replace(/[^\dKk]/g, '');
			let dato = this.user.rut;
			let largo = dato.length;
			if (largo === 1) {
			this.dv = dato;
			this.user.rut = '';
			this.digito(this.user.rut, this.dv);
			this.formato()
			} else if (largo > 1) {
			this.dv = dato.substring(largo - 1);
			this.user.rut = dato.substring(largo - 1, 0);
			this.digito(this.user.rut, this.dv);
			this.formato()
			}
		},
		digito(rut,dv) {
			let suma = 0;
			let multiplicador = 2;
			while(rut !== 0){
			if (multiplicador === 8) {
				multiplicador = 2;
			}
			suma += (rut % 10) * multiplicador;
			rut = Math.trunc(rut / 10);
			multiplicador++;
			}
			suma = 11 - (suma % 11);
			switch (suma) {
			case 11:
				this.check = ("0" === dv);
				break;
			case 10:
				this.check = ("K" === dv.toUpperCase());
				break;
			default:
				this.check = (suma.toString() === dv);
				break;
			}
		},
		formato() {
			let rut = (this.user.rut) ? (new Intl.NumberFormat("es-CL").format(parseInt(this.user.rut))) + '-' : '';
			this.user.rut = rut + this.dv;
		},
		loginUser(){
			if(!this.$v.user.$invalid){
				this.loading = true
				this.error = null
				this.$store.dispatch('login', this.user).then(() => {
					this.$router.push('/');
					this.loading = false
				}).catch( () =>{
					this.loading = false
					this.error = "Rut y/o Contraseña Inválidos";
				})
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
